const DEFAULT_OPTIONS = {
  targetSelector: '#app',
  messageType: 'vite-iframe-resize',
  debounceMs: 200
}

const debounce = (fn, delay = 150) => {
  let timeout
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => fn(...args), delay)
  }
}

export const startIframeResizeObserver = (options = {}) => {
  if (typeof window === 'undefined') {
    return
  }

  if (window.parent === window) {
    return
  }

  if (!('ResizeObserver' in window)) {
    return
  }

  const config = { ...DEFAULT_OPTIONS, ...options }
  const target = document.querySelector(config.targetSelector)

  if (!target) {
    return
  }

  const postHeight = () => {
    const height = target.offsetHeight
    window.parent.postMessage(
      { type: config.messageType, height },
      '*'
    )
  }

  const debouncedPost = debounce(postHeight, config.debounceMs)
  const observer = new ResizeObserver(() => debouncedPost())

  observer.observe(target)
  window.addEventListener('resize', debouncedPost)
  window.addEventListener('load', debouncedPost)

  debouncedPost()

  return () => {
    observer.disconnect()
    window.removeEventListener('resize', debouncedPost)
    window.removeEventListener('load', debouncedPost)
  }
}
